module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"gl":{"title":"Cambiar Localización","explicacion":"Para cambiar a localización fai click no mapa. O punteiro azul marca a localización actual da aplicación. Tamén podes empregar a barra de busca para procurar algunhas rúas. Unha vez atopada a posición que queres preme no mapa para marcala.","search-label":"Introduza enderezo"},"es":{"title":"Cambiar Localización","explicacion":"Para cambiar la localización haz click en el mapa. El puntero azul marca a localización actual de la aplicación. También puedes usar a barra de busqueda para encontrar algunhas calles. Una vez encontrada la posición que quieres, haz click en el mapa para marcala.","search-label":"Introduzca dirección"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/ModalChangePosition.vue
// module id = 84
// module chunks = 0